<template>
  <div class="wl_company_pup">
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      v-loading = "loading"
      center
      :title="content"
      :visible.sync="dialogVisible"
      destroy-on-close
      width="756px"
    >
      <div>
        <el-form ref="form" :rules="rules" :model="form" label-width="140px">
          <el-form-item
            label="单位名称:"
            prop="dwmc"
            :rules="{
              required: true,
              validator: (rule, value, callback) => {
                lengthValidate(rule, value, callback, 'bt', 200);
              },
              trigger: ['blur', 'change'],
            }"
          >
            <el-input
              v-model.trim="form.dwmc"
              style="width: 310px"
              @input="inputChange"
            />
          </el-form-item>
          <el-form-item
            label="统一社会信用代码:"
            prop="shtyxydm"
            :rules="{
              required: true,
              validator: (rule, value, callback) => {
                lengthValidate(rule, value, callback, 'bt', 100);
              },
              trigger: ['blur', 'change'],
            }"
          >
            <el-input
              v-model.trim="form.shtyxydm"
              :readonly="disabled"
              style="width: 310px"
            />
          </el-form-item>
          <!-- <el-form-item label="业务类型:" prop="ywlx">
            <el-select
              :disabled="disabled"
              multiple
              v-model="form.ywlx"
              placeholder="请选择"
              style="width: 310px"
            >
              <el-option label="生产" value="1"></el-option>
              <el-option label="使用" value="2"></el-option>
              <el-option label="经营" value="3"></el-option>
              <el-option label="运输" value="4"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item
            label="单位地址:"
            prop="dwdz"
            :rules="{
              required: true,
              validator: (rule, value, callback) => {
                lengthValidate(rule, value, callback, 'bt', 600);
              },
              trigger: ['blur', 'change'],
            }"
          >
            <el-input
              v-model.trim="form.dwdz"
              :title="form.dwdz"
              style="width: 310px"
            />
          </el-form-item>
          <el-form-item
            label="法人/经营者:"
            prop="frmc"
            :rules="{
              required: true,
              validator: (rule, value, callback) => {
                lengthValidate(rule, value, callback, 'bt', 200);
              },
              trigger: ['blur', 'change'],
            }"
          >
            <el-input
              v-model.trim="form.frmc"
              :readonly="disabled"
              style="width: 310px"
            />
          </el-form-item>
          <el-form-item label="单位座机:" prop="dwzj">
            <el-input v-model.trim="form.dwzj" style="width: 310px" />
          </el-form-item>
          <el-form-item label="联系人手机:" prop="dwsj">
            <el-input v-model.trim="form.dwsj" style="width: 310px" />
          </el-form-item>
        </el-form>
        <p>提示:&nbsp;请严格按照营业照信息填写!</p>
      </div>
      <div slot="footer">
        <el-button
          v-preventReClick
          type="primary"
          style="background: #4170ff; margin-bottom: 20px"
          @click="baocun"
        >保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { lengthValidate } from '@/assets/js/validate'
import { addOrUpdSave, detail, selYzddwByDwmc } from '@/assets/js/wldw.js'
export default {
  components: {},
  props: {
    content: String,
    type: String
  },
  data() {
    const phoneValidator = (rule, value, callback) => {
      const reg1 = /^(0\d{2,3}-\d{7,8})$/ // 座机
      const reg2 = /^1[3456789]\d{9}$/
      if (!reg1.test(value) && !reg2.test(value)) {
        callback(new Error('请输入正确的电话或手机号格式'))
      }
      callback()
    }
    var telphoneValidate = (rule, value, callback) => {
      // if (!value) {
      //   callback(new Error("手机号不能为空!"));
      // } else
      if (value) {
        const reg = /^1[3456789]\d{9}$/
        if (!reg.test(value)) {
          callback(new Error('请输入正确的手机号'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      loading: false,
      disabled: false,
      dialogVisible: false,
      form: {
        id: '',
        dwId: '',
        glrwdwId: '',
        dwmc: '',
        shtyxydm: '',
        ywlx: '',
        dwdz: '',
        frmc: '',
        dwzj: '',
        dwsj: ''
      },
      rules: {
        // dwmc: [{ required: true, message: "请输入单位名称", trigger: "blur" }],
        // shtyxydm: [
        //   {
        //     required: true,
        //     message: "请输入社会统一信用代码",
        //     trigger: "blur",
        //   },
        // ],
        ywlx: [{ required: true, message: '请选择业务类型', trigger: 'blur' }],
        // dwdz: [{ required: true, message: "请输入单位地址", trigger: "blur" }],
        // frmc: [
        //   { required: true, message: "请输入法人/经营者名称", trigger: "blur" },
        // ],
        dwzj: [
          {
            required: true,
            // validator: phoneValidator,
            trigger: ['blur', 'change']
          }
        ],
        dwsj: [
          {
            validator: telphoneValidate,
            trigger: ['blur', 'change']
          }
        ]
      }
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    lengthValidate,
    inputChange(val) {
      this.disabled = false
      // 如果公司名称输入不为空
      if (val.replace(/[ ]/g, '').length != 0) {
        // 延时0.5s根据公司名称获取相应信息，并且不可修改
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.handleChangeName(val)
        }, 1000)
      }
    },
    baocun() {
      // 将业务类型转换字符串
      /* this.form.ywlx = this.form.ywlx.join(","); */

      this.$refs['form'].validate((valid) => {
        if (valid) {
          // 添加时
          if (this.type == 'add') {
            this.loading = true
            addOrUpdSave(this.form).then((e) => {
              this.loading = false
              this.$message({
                showClose: true,
                message: '添加成功',
                type: 'success'
              })
              this.dialogVisible = false
              this.$parent.getTableData()
            }).catch((error) => {
              this.loading = false
            })
          }
          // 修改时
          if (this.type == 'edit') {
            this.loading = true
            addOrUpdSave(this.form).then((e) => {
              this.loading = false
              this.$message({
                showClose: true,
                message: '编辑成功',
                type: 'success'
              })
              this.dialogVisible = false
              this.$parent.getTableData()
            }).catch((error) => {
              this.loading = false
            })
          }
        }
      })
    },
    handleChangeName(dwmc) {
      selYzddwByDwmc(dwmc).then((e) => {
        if (e.data.data.dwmc) {
          // 将字符串型业务类型转换数组绑定
          // e.data.data.ywlx = e.data.data.ywlx.split(",");
          this.disabled = true
          this.form = e.data.data
        }
      })
    },
    // 编辑时获取信息
    queryDwById(id) {
      detail(id).then((e) => {
        this.dialogVisible = true
        // e.data.data.ywlx = e.data.data.ywlx.split(",");
        this.form = e.data.data
      })
    }
  }
}
</script>
<style scoped lang='less'>
.wl_company_pup {
  .el-form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  p {
    margin: 0;
    text-align: center;
    color: red;
  }
  /deep/.el-dialog__header {
    padding: 40px 20px 10px !important;
    .el-dialog__title {
      width: 120px;
      height: 28px;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #434343;
      line-height: 28px;
    }
    .el-dialog__close {
      color: #000000 !important;
      font-weight: bold;
    }
  }
}
</style>
